import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatErr, zl } from "@/lib/api";

const STATUSES = ["nowe", "w trakcie", "potwierdzone", "zrealizowane", "anulowane"];
const fmt = (iso) => new Date(iso).toLocaleString("pl-PL", { dateStyle: "medium", timeStyle: "short" });
const fmtDay = (d) => (d ? new Date(d + "T12:00").toLocaleDateString("pl-PL", { day: "numeric", month: "long", year: "numeric" }) : "—");
const waNum = (p) => (p || "").replace(/\D/g, "");

const Item = ({ q, onPatch, onDelete }) => {
  const [note, setNote] = useState(q.note || "");
  return (
    <article className={`inq ${q.status === "nowe" ? "nowe" : ""}`} data-testid={`inquiry-card-${q.id}`}>
      <div className="inq-head">
        <h3>{q.name} · <em style={{ color: "var(--gold)" }}>{q.occasion}</em></h3>
        <span className="label">{fmt(q.created_at)}</span>
      </div>
      <div className="inq-meta">
        <div><span>Data przyjazdu</span>{fmtDay(q.date)}</div>
        <div><span>Obiekt</span>{q.place}</div>
        <div><span>Telefon</span>{q.phone || "—"}</div>
        <div><span>Budżet</span>{q.budget || "—"}</div>
        <div><span>Dodatki</span>{q.addons?.length ? q.addons.join(", ") : "—"}</div>
        <div><span>Szacunek</span>{q.estimate ? `od ${zl(q.estimate - (q.discount_amount || 0))}` : "—"}</div>
        {q.discount_code && <div data-testid={`inquiry-discount-${q.id}`}><span>Kod rabatowy</span>{q.discount_code} (−{zl(q.discount_amount)})</div>}
        <div><span>Powiadomienie e-mail</span>{q.email_sent === true ? "wysłane" : q.email_sent === false ? "błąd wysyłki" : "—"}</div>
      </div>
      {q.details && <pre>{q.details}</pre>}
      <div className="fe-field"><label>Notatka wewnętrzna</label>
        <input value={note} onChange={(e) => setNote(e.target.value)} onBlur={() => note !== (q.note || "") && onPatch(q.id, { note })} placeholder="np. zaliczka wpłacona" data-testid={`inquiry-note-${q.id}`} /></div>
      <div className="inq-tools">
        <select value={q.status} onChange={(e) => onPatch(q.id, { status: e.target.value })} data-testid={`inquiry-status-${q.id}`}>
          {STATUSES.map((s) => <option key={s}>{s}</option>)}
        </select>
        {waNum(q.phone) && <a className="mini" href={`https://wa.me/${waNum(q.phone)}`} target="_blank" rel="noreferrer">WhatsApp</a>}
        {q.phone && <a className="mini" href={`tel:${q.phone}`}>Zadzwoń</a>}
        <button className="mini" onClick={() => navigator.clipboard.writeText(q.message || "").then(() => toast.success("Skopiowano treść"))}>Kopiuj wiadomość</button>
        <button className="mini danger" onClick={() => window.confirm("Usunąć to zapytanie?") && onDelete(q.id)} data-testid={`inquiry-delete-${q.id}`}>Usuń</button>
      </div>
    </article>
  );
};

export const Inquiries = () => {
  const [list, setList] = useState(null);
  const [filter, setFilter] = useState("wszystkie");

  useEffect(() => { api.get("/inquiries").then(({ data }) => setList(data)).catch((e) => toast.error(formatErr(e))); }, []);

  const patch = async (id, body) => {
    try {
      const { data } = await api.patch(`/inquiries/${id}`, body);
      setList((l) => l.map((x) => (x.id === id ? data : x)));
      const msg = { blocked: "Zapisano – dzień zablokowany w kalendarzu", unblocked: "Zapisano – dzień odblokowany w kalendarzu" }[data.calendar];
      toast.success(msg || "Zapisano");
    }
    catch (e) { toast.error(formatErr(e)); }
  };
  const del = async (id) => {
    try { await api.delete(`/inquiries/${id}`); setList((l) => l.filter((x) => x.id !== id)); toast.success("Usunięto"); }
    catch (e) { toast.error(formatErr(e)); }
  };

  if (!list) return <p className="adm-sub">Ładowanie…</p>;
  const shown = filter === "wszystkie" ? list : list.filter((q) => q.status === filter);

  return (
    <div data-testid="admin-inquiries">
      <h1>Zapytania</h1>
      <p className="adm-sub">Wszystkie zapytania wysłane przez formularz na stronie. Oznaczenie zapytania jako „potwierdzone” automatycznie blokuje ten dzień w kalendarzu terminów.</p>
      <div className="stat-row" style={{ marginTop: 28 }}>
        <div><b data-testid="stat-total">{list.length}</b>wszystkie</div>
        <div><b data-testid="stat-new">{list.filter((q) => q.status === "nowe").length}</b>nowe</div>
        <div><b>{list.filter((q) => q.status === "potwierdzone").length}</b>potwierdzone</div>
      </div>
      <div className="filters">
        {["wszystkie", ...STATUSES].map((s) => <button key={s} className={`tab${filter === s ? " on" : ""}`} onClick={() => setFilter(s)} data-testid={`inquiry-filter-${s.replace(" ", "-")}`}>{s}</button>)}
      </div>
      <div className="inq-list">
        {shown.length ? shown.map((q) => <Item key={q.id} q={q} onPatch={patch} onDelete={del} />) : <p className="adm-sub" data-testid="inquiries-empty">Brak zapytań.</p>}
      </div>
    </div>
  );
};
